const u = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=240&h=240&q=70`;

// Starter photos for each category tile; admins can replace any of them.
export const CATEGORY_PHOTOS = {
  dogs: u("photo-1724367281416-cf18867ad712"),
  cats: u("photo-1529778873920-4da4926a72c2"),
  birds: u("photo-1504579264001-833438f93df2"),
  reptiles: u("photo-1619816128374-a6b4766ca92c"),
  aquatics: u("photo-1625369708811-65ebfc5ca632"),
  "small-pets": u("photo-1425082661705-1834bfd09dca"),
  "supplies-services": u("photo-1591946614720-90a587da4a36"),
  livestock: u("photo-1612225330565-f79af9f92168"),
  rescue: u("photo-1475954704693-ac6850a71ee0"),
  "lost-found": "https://images.pexels.com/photos/6468223/pexels-photo-6468223.jpeg?auto=compress&cs=tinysrgb&w=240&h=240&fit=crop",
  iso: u("photo-1664465920643-e2c5a5665566"),
};

export const tilePhoto = (id, ov = {}) => ((ov.display || "photo") === "photo" ? (ov.photo || CATEGORY_PHOTOS[id] || "") : "");
